var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-msg-master"},[_c('div',[_c('p',{domProps:{"textContent":_vm._s(_vm.msgText)}}),_c('p',[_c('button',{on:{"click":_vm.handleError}},[_vm._v("У реду")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }